module.exports = __webpack_public_path__ + "assets/img/phone.42bb5446.png";